export const environment = {
  production: true,
  // backendApi: 'https://admin.shiny-nft.com/api/v1/admin',
  backendApi: "https://api.everydaygoddesses.io/api/v1/admin",
  infinityNumber: 600000000,
  // backendApi: 'http://localhost:3000/api/v1/admin'
};
